import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {

  errorMessage:string = "Your session has expired. Please login again on ETS and relaunch Trip View.";

  ngOnInit(): void {
  }

}
